import { render, staticRenderFns } from "./ResortIntegrations.vue?vue&type=template&id=bb5a687e&"
import script from "./ResortIntegrations.vue?vue&type=script&lang=js&"
export * from "./ResortIntegrations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports